<template>
  <div class="docdetail">
    <ball></ball>
    <div class="nav">
      <van-nav-bar
        title="医生信息"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
      />
    </div>
    <div class="doc_cell">
      <div class="doc_cell_icon">
        <van-image
          v-if="!docinfo.PersonImage"
          round
          fit="cover"
          height="60px"
          width="60px"
          :src="require('@/assets/img/doc_item.png')"
        />
        <img v-else :src="imgSrc + docinfo.PersonImage" class="doc_img" />
      </div>
      <div class="doc_cell_info">
        <div class="info_name">
          {{ docinfo.PersonName }}-{{ docinfo.DepartmentName }}
        </div>
        <div class="info_rank">{{ docinfo.PersonLevel }}</div>
      </div>
    </div>
    <div class="doc_tab">
      <div class="doc_tab_nav">
        <div :class="'doc_tab_nav_btn1'">
          医生简介
        </div>
      </div>

      <div class="doc_tab_introduce">
        <div class="introduce">
          <div class="introduce_icon">
            <van-icon
              name="star-o"
              size="25"
              color=" #ffc34d"
              style="margin:0px auto"
            />
          </div>
          <div class="introduce_info">
            简介：
            <div class="introduce_info_text">
              {{docinfo.PersonIntroduction}}
            </div>
          </div>
        </div>
        <!-- <div class="introduce">
          <div class="introduce_icon">
            <van-icon
              name="notes-o"
              size="25"
              color=" #4dff4d"
              style="margin:0px auto"
            />
          </div>
          <div class="introduce_info">
            简介
            <div class="introduce_info_text">
              我的阿萨德艾斯的行政村自行车自行车我去去在自相残杀打算定位球当前周星驰现在啊实打实的撒对这些
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div>
      <van-button type="info" block @click="godetail()">确   认   挂    号</van-button>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
export default {
  data() {
    return {
       imgSrc: "data:image/jpeg;base64,",
      navBtnFlag: "1",
      DoctorID: "",
      deptid: "",
      docinfo: null,
      regFee:null,
      DoctorName:"",
      seedate:"",
      deptName:""
    };
  },
  components: {
    Nav
  },
  mounted() {
    this.DoctorID = this.$route.query.DoctorID;
    this.deptid = this.$route.query.deptid;
    this.regFee=this.$route.query.regFee
    this.DoctorName=this.$route.query.DoctorName
    this.seedate=this.$route.query.seedate
    this.deptName=this.$route.query.deptName
    this.getdoctorinfo();
  },
  methods: {
    godetail(){
         this.$router.push({
        path: "/ylzyy_reg_detail",
        query: {
          DoctorID:this.DoctorID,
          deptid:this.deptid,
          deptName: this.deptName,
          regFee: this.regFee,
          DoctorName:this.DoctorName,
          seedate:this.seedate
        },
      });
    },
    async getdoctorinfo() {
      try {
        this.$showLoad();
        let data = {
          DepartmentID: this.DoctorID
        };
        let url = "/register/QueryPersonInfo";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          data => {
            // this.wx_pub_id = data.wx_pub_id;
            this.docinfo = data.data.data?.List?.Item;
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
    changetabnav(falg) {
      this.navBtnFlag = falg;
    },
    onClickLeft() {
      this.$router.push("/index");
    }
  }
};
</script>

<style lang="scss" scoped>
.docdetail {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f1f1f1;
  font-family: PingFang SC;
  .doc_cell {
    background-color: #fff;
    height: 10vh;
    padding: 10px;
    display: flex;
    flex-direction: row;
    margin-bottom: 1vh;
    .doc_img {
      width: 60px;
      height: 60px;
      border-radius: 99px;
    }
    .doc_cell_icon {
      width: 20vw;
      margin-right: 3vw;
    }
    .doc_cell_info {
      font-size: 16px;
      width: 50vw;
      .info_name {
        margin-bottom: 2vh;
      }
      .info_rank {
        font-size: 14px;
        color: #666;
      }
    }
  }
  .doc_tab {
    height: 85VH;
    .doc_tab_nav {
      display: flex;
      flex-direction: row;
    background-color: #fff;

      .doc_tab_nav_btn1 {
        width: 100vw;
        text-align: center;
        line-height: 5vh;
        color: #5b8df6;
        border-bottom: 2px solid #c5c5c5;
      }
    }
    .doc_tab_introduce {
      display: flex;
      flex-direction: column;
    background-color: #fff;

      .introduce {
        display: flex;
        flex-direction: row;
        padding: 10px;
        border-bottom: 1px solid #c5c5c5;
        .introduce_icon {
          width: 8vw;
        }
        .introduce_info {
          font-size: 16px;
        }
        .introduce_info_text {
          margin-top: 1vh;
          width: 85vw;
          font-size: 14px;
          color: #666;
          white-space: normal;
          word-break: break-all;
          word-wrap: break-word;
        }
      }
    }
  }
}
</style> 

